
export class Proctor {
  id: string;
  uri: string;
  startDateTime: Date;
  testDate?: any;
  testTime?: any;
  duration?: any;

  constructor(
    id: string,
    uri: string,
    startDateTime: Date,
    testDate?: any,
    testTime?: any,
    duration?: any
  ) {
    this.id = id;
    this.uri = uri;
    this.startDateTime = startDateTime;
    this.testDate = testDate;
    this.testTime = testTime;
    this.duration = duration;
  }
}
